import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedProfessionalRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-[#FF9F68]"></div>
      </div>
    );
  }

  if (!user || user.role !== 'professional') {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedProfessionalRoute;
